import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

export const UncheckedSvg = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <rect x="0.5" y="0.5" width="17" height="17" rx="4.5" stroke="currentColor" />
            </svg>
        </SvgIcon>
    );
};
